import {iterateNodes} from './dom';

export default class Accordion {
    constructor(settings){
        let settingSelectors = settings.selectors || [];
        let closeEvent = settings.closeEvent || false;
        let selectors = [].concat(settingSelectors);

        selectors.map(selector => {
            iterateNodes(selector, Accordion.addTransitionListener, closeEvent)
        });
    }

    static addTransitionListener(node, closeEvent){
        node.addEventListener('click', () => Accordion.transitionMaxHeight(node));

        if(closeEvent !== false){
            window.addEventListener(closeEvent, () => {
                Accordion.transitionMaxHeight(node);
            });
        }
    }

    static transitionMaxHeight(node){
        let tabContent = node.nextElementSibling;
        tabContent.classList.toggle('-open');

        if (tabContent.style.maxHeight){
            tabContent.style.maxHeight = null;
        } else {
            tabContent.style.maxHeight = tabContent.scrollHeight + 'px';
        }
    }
}